import { baseApi, Point } from "@racoon/api";

/** === Types === */
interface DepartInfo {
  id: number;
  shift_id: number;
  created_at: string;
  updated_at: string;
  // Add additional fields depending on API response
  [key: string]: any;
}

interface RouteStep {
  points: string;
  duration: string; // ISO 8601 format like "PT14M21S"
  length: number;
}

interface RouteLeg {
  steps: RouteStep[];
}

export interface RouteWaypointsResponse {
  legs: RouteLeg[];
  waypoints: any[];
}

interface RouteWaypointsRequest {
  waypoints: Point[];
}

const costProviderApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    /**
     * GET /v1/platform/cost_provider/depart_info/{shift_id}
     */
    getDepartInfo: build.query<DepartInfo, number>({
      query: (driver_on_shift_id) => ({
        url: `/v1/platform/cost_provider/depart_info`,
        method: "GET",
        params: { driver_on_shift_id },
      }),
      // Always refetch, never use cache
      keepUnusedDataFor: 0,
      providesTags: (result, error, shiftId) => [{ type: "DriverOnShift" as const, id: shiftId }],
    }),

    /**
     * POST /v1/platform/cost_provider/route_waypoints
     */
    calculateRouteWaypoints: build.mutation<RouteWaypointsResponse, RouteWaypointsRequest>({
      query: (data) => ({
        url: "/v1/platform/cost_provider/route_waypoints",
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const { useLazyGetDepartInfoQuery, useCalculateRouteWaypointsMutation } = costProviderApi;
